import {
  Carousel as _Carousel,
  UncontrolledCarousel as _UncontrolledCarousel,
  CarouselProps as _CarouselProps,
  UncontrolledCarouselProps as _UncontrolledCarouselProps
} from "reactstrap";

export const Carousel = _Carousel;
export const UncontrolledCarousel = _UncontrolledCarousel;

export type CarouselProps = _CarouselProps;
export type UncontrolledCarouselProps = _UncontrolledCarouselProps;
